import { HeroMetric, HeroMetricsContainer } from '../../components/display/hero-metrics';
import React from 'react';
import { CampaignMetrics } from 'shared/src/domain/metrics/metrics-types';

type Props = {
  metrics: CampaignMetrics;
};

export function CampaignHeroMetrics({ metrics }: Props) {
  const {
    delivery_pacing,
    spend_pacing,
    on_pace_spend,
    actual_media_spend,
    margin_actual,
    planned_margin,
    target_margin,
    on_pace_revenue,
    effective_billable_revenue
  } = metrics;

  return (
    <HeroMetricsContainer isCampaign>
      <div className="flex justify-between gap-1">
        <HeroMetric
          primary={{ name: 'Delivery Pacing', value: delivery_pacing, type: 'percentage' }}
          secondary={{
            type: 'currency',
            name: `Billable Revenue Delivered`,
            value: effective_billable_revenue
          }}
          tertiary={{ type: 'currency', name: 'On-pace target', value: on_pace_revenue }}
        />
        <HeroMetric
          primary={{ name: 'Spend Pacing', value: spend_pacing, type: 'percentage' }}
          secondary={{ type: 'currency', name: `Media spend`, value: actual_media_spend }}
          tertiary={{ type: 'currency', name: 'On-pace spend', value: on_pace_spend }}
        />
        <HeroMetric
          primary={{ name: 'Margin', value: margin_actual, type: 'percentage' }}
          secondary={{
            type: 'margin',
            value: margin_actual,
            target: planned_margin || 0
          }}
          tertiary={{
            type: 'discount',
            planned: { type: 'percentage', name: 'Planned', value: planned_margin || 0 },
            target: { type: 'percentage', name: 'Target', value: target_margin || 0 }
          }}
        />
      </div>
    </HeroMetricsContainer>
  );
}
